/** Desktop grid columns for the hero stats row, keyed by the number of stats. */
export const STATS_COLS: Record<number, string> = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
}
